import { useState } from "react";
import { feedCategories, feedItems } from "@/mocks/feed";

function formatWatchers(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}W`;
  return String(n);
}

export default function Board() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? feedItems : feedItems.filter((i) => i.category === active);

  return (
    <section id="board" className="border-y border-background-200 bg-background-100/50 py-14 md:py-20">
      <div className="container-site">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-1 flex items-center gap-2 text-sm font-medium text-secondary-700">
              <i className="ri-community-fill"></i> 正在发酵
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">围观广场</h2>
            <p className="mt-2 text-sm text-foreground-600">挑一个你感兴趣的话题，进去一起蹲后续、催更新。</p>
          </div>

          <div className="flex flex-wrap gap-2 rounded-full border border-background-200 bg-background-50 p-1">
            {feedCategories.map((c) => (
              <button
                key={c.key}
                onClick={() => setActive(c.key)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  active === c.key
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-700 hover:bg-background-200"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-shadow hover:-translate-y-1"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 chip text-background-50 ${
                    item.tag === "新瓜开张"
                      ? "bg-accent-500"
                      : item.tag === "催更进行时"
                        ? "bg-secondary-500"
                        : "bg-primary-500"
                  }`}
                >
                  <i
                    className={`${
                      item.tag === "新瓜开张"
                        ? "ri-sparkling-line"
                        : item.tag === "催更进行时"
                          ? "ri-bubble-chart-line"
                          : "ri-eye-line"
                    }`}
                  ></i>
                  {item.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="chip w-fit bg-secondary-100 text-secondary-800">{item.category}</span>
                <h3 className="mt-3 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i> {formatWatchers(item.watchers)} 围观
                  </span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-refresh-line"></i> 已更 {item.updates} 期
                  </span>
                  <span className="whitespace-nowrap">{item.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}